import React, { Component } from "react"
import ContactForm from './components/contact-form'
import { contactsService } from '../../services/tibesa.api'
import Swal from 'sweetalert2'

export default class ContactAdd extends Component {
    constructor(props) {
        super(props);
    }

    submitChanges(formData) {
        Swal.fire({
            title: '¿Seguro que deseas guardar el contacto?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            cancelButtonText: 'Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                return contactsService.create(formData)
                    .then(response => {
                        return response;
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                            `Error en la petición: ${error}`
                        )
                    });
            },
            allowOutsideClick: () => !Swal.isLoading()
        })
            .then((response) => {
                console.log(response);
                if (response.value && response.value.data && response.value.data.status == 200) {
                    Swal.fire(
                        '¡Perfecto!',
                        '¡Nuevo Contacto creado!',
                        'success'
                    ).then(() => {
                        if (response.value.data.results) {
                            window.location.href = `/contacts/${response.value.data.results}`;
                        }
                        else {
                            window.location.href = '/contacts';
                        }
                    });
                } else if(!response.dismiss == 'cancel') {
                    Swal.fire(
                        'Algo salio mal :C',
                        'Hubo un error al realizar la petición',
                        'error'
                      );
                }
            });
    }


    render() {
        return (
            <>
                <div className="air__utils__heading">
                    <a href="/Contacts">Listado de contactos</a><span>{" "}/{" "}Agregar Contacto</span>
                </div>
                <ContactForm onSubmit={this.submitChanges}></ContactForm>
            </>
        )
    }
}
